
import Service from "../../../Services/index";

const TransactionType = {
    namespaced: true,
    state: {
        transactionTypes: []
    },
    mutations: {
        SET_TRANSACTION_TYPES: (state, data) => {
            state.transactionTypes = data
        }
    },
    actions: {
        setTransactionTypes({ commit }) {
            return Service.Transaction.getTransactionTypes()
                .then(data => {
                    commit("SET_TRANSACTION_TYPES", data)
                })
        }
    }
}

export default TransactionType
